import { Component, defineComponent } from 'vue';
import MainContentCode from '@/presentation/components/main-content/main-content-class';
import RouterView from '@/presentation/components/router-view/router-view.vue';
import Header from '@/presentation/components/header/header.vue';
import Navigation from '@/presentation/components/navigation/navigation.vue';
import LoadingAnimation from '@/presentation/components/loading-animation/loading-animation.vue';

export default defineComponent({
	components: {
		Header: Header as Component,
		Navigation: Navigation as Component,
		RouterView: RouterView as Component,
		LoadingAnimation: LoadingAnimation as Component
	},
	setup: () => {
		const code = new MainContentCode();

		return {
			layoutElementStyling: code.layoutElementStyling,
			loadingInProgress: code.loadingInProgress,
			routeIsListing: code.routeIsListing
		};
	}
});
